import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CTA_URL, trackCheckoutClick } from '../lib/constants';

/**
 * Sticky bottom checkout bar. Appears once the user scrolls past the first
 * (hero) CTA button and hides on the final CTA section.
 */
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const trigger = document.getElementById('hero-cta');
    const finalCta = document.getElementById('cta-final');
    const onScroll = () => {
      const triggerBottom = trigger ? trigger.getBoundingClientRect().bottom : 600;
      const pastHero = triggerBottom < 0;
      const inFinal = finalCta ? finalCta.getBoundingClientRect().top < window.innerHeight - 80 : false;
      setVisible(pastHero && !inFinal);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-32" data-mp="2f3ix4w0zfl9a">
      {visible ? <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 30
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-navy-700/60 bg-navy-900/98 px-3 pb-[max(0.6rem,env(safe-area-inset-bottom))] pt-2.5 backdrop-blur" data-id="element-33" data-mp="21cnn3geqyy44">
          <div className="mx-auto flex max-w-3xl items-center gap-3" data-id="element-34" data-mp="1wb6nrpbwvjpn">
            <div className="hidden shrink-0 flex-col leading-tight sm:flex" data-id="element-35" data-mp="1ifmcng2fc5ss">
              <span className="text-[10.5px] font-semibold uppercase tracking-[0.14em] text-gold-300" data-id="element-36" data-mp="1ndnvbzvxu33q">
                Oferta de lanzamiento
              </span>
              <span className="font-display text-xl font-bold text-white" data-id="element-37" data-mp="3hqm4gg5witph">
                $12.99 <span className="text-sm font-semibold text-white/50 line-through" data-id="element-38" data-mp="3hojf7yckp4lt">$264</span>
              </span>
            </div>
            <motion.a href={CTA_URL} onClick={() => trackCheckoutClick('floating_bar')} animate={{
          scale: [1, 1.035, 0.985, 1.03, 0.99, 1],
          rotate: [0, -1.6, 1.6, -1.1, 0.7, 0],
          x: [0, -3, 3, -2, 1, 0]
        }} transition={{
          duration: 0.7,
          ease: 'easeInOut',
          repeat: Infinity,
          repeatDelay: 2.6
        }} whileTap={{
          scale: 0.97
        }} className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-gold-500 px-4 py-3.5 text-center text-[13px] font-extrabold uppercase leading-tight tracking-tight text-white shadow-[0_0_0_0_rgba(200,145,47,0.55)] transition-colors hover:bg-gold-600 sm:text-[15px]" data-id="element-39" data-mp="3ba41ed3jhk2n">
              Quiero el sistema por $12.99
              <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-40" data-mp="o5rg4o7gmduk" />
            </motion.a>
          </div>
          <p className="mt-1.5 text-center text-[10px] font-medium text-white/50 sm:text-[11px]" data-id="element-41" data-mp="t4b1ame8bllv">
            Descarga inmediata · Pago único · Garantía de 7 días
          </p>
        </motion.div> : null}
    </AnimatePresence>;
}